const SRC = "https://js.hsforms.net/forms/v2.js";
let loadPromise: Promise<void> | null = null;

export function loadHubSpotEmbed(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve();
  if (loadPromise) return loadPromise;

  const existing = document.querySelector<HTMLScriptElement>(`script[src="${SRC}"]`);
  if (existing) {
    loadPromise = (window as any).hbspt
      ? Promise.resolve()
      : new Promise((resolve) => {
          existing.addEventListener("load", () => resolve());
        });
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SRC;
    s.defer = true;
    s.addEventListener("load", () => resolve());
    s.addEventListener("error", () => {
      loadPromise = null;
      reject(new Error("HubSpot embed script failed to load"));
    });
    document.body.appendChild(s);
  });
  return loadPromise;
}